import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface IEvents {
  events_id: number;
  events_period_start: string;
  events_period_end: string;
}

export interface IFormQuestion {
  question_no: number;
  question_content: string;
  question_format: string;
  question_choices: string;
  question_flag: boolean;
  question_hidden_flag: boolean;
}

export interface ISurvey {
  forms_id: number;
  forms_title: string;
  forms_top_image: string;
  forms_bottom_image: string;
  forms_answer_limit: number;
  forms_description: string;
  forms_hidden_flag: boolean;
  event: IEvents[];
  answered_count: number;
  form_questions: IFormQuestion[];
}

export const surveyApi = createApi({
  reducerPath: 'surveyApi',
  tagTypes: ['survey'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getAllSurvey: builder.query<ISurvey[], string>({
      query: params => ({
        url: `/forms${params && '?' + params}`,
        method: 'GET',
      }),
      providesTags: ['survey'],
      transformResponse: (response: {
        refer_to_the_form_list_data: ISurvey[];
      }) => response.refer_to_the_form_list_data,
    }),
    getQuestions: builder.query({
      query: () => ({
        url: '',
        method: 'GET',
      }),
    }),
    createSurvey: builder.mutation<any, any>({
      query(body) {
        return {
          url: '/forms',
          method: 'POST',
          data: body,
        };
      },
      invalidatesTags: ['survey'],
    }),
    deleteSurvey: builder.mutation<any, string>({
      query(id) {
        return {
          url: `/forms/${id}`,
          method: 'Delete',
        };
      },
      invalidatesTags: ['survey'],
    }),
    updateSurvey: builder.mutation<any, any>({
      query({ id, body }) {
        return {
          url: `/forms/${id}`,
          method: 'PUT',
          data: body,
        };
      },
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          const delayUpdate = setTimeout(() => {
            dispatch(
              surveyApi.endpoints.getAllSurvey.initiate('', {
                forceRefetch: true,
              }),
            );
            clearTimeout(delayUpdate);
          }, 2000);
        } catch (err) {
          console.log(err);
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllSurveyQuery,
  useCreateSurveyMutation,
  useDeleteSurveyMutation,
  useUpdateSurveyMutation,
} = surveyApi;
